import { defineAsyncComponent } from 'vue'
export default {
  v3: defineAsyncComponent(() => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/layouts/v3.vue").then(m => m.default || m))
}